import axiosFetch from './config';

export const getLoginStatus = async (phoneNumber) => {
  return axiosFetch({
    method: "GET",
    url: `/auth/signIn/${phoneNumber}`
  })
}


export const postSignIn = async (data) => {
  return axiosFetch({
    method: "POST",
    data,
    url: "/auth/signIn",
  })
}


export const postSignUp = async (data) => {
  return axiosFetch({
    method: "POST",
    data,
    url: "/auth/signUp",
  })
}

export const SingUpSendCode = async (data) => {
  let token = await localStorage.getItem('registerToken')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/auth/signUp/otp/send',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const postSingUpSendCode = async (data) => {
  let token = await localStorage.getItem('registerToken')
  console.log(token);
  return axiosFetch({
    method: 'POST',
    data,
    url: '/auth/signUp/otp/send',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const recoveryPasswordSendCode = async (data) => {
  let token = await localStorage.getItem('recoveryPasswordToken')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/auth/signUp/otp/send',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
}
export const SingUpVerify = async (data) => {
  ////console.log(data);
  let token = await localStorage.getItem('registerToken')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/auth/signUp/otp/verify',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const postSingUpVerify = async (data) => {
  let token = await localStorage.getItem('registerToken')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/auth/signUp/otp/verify',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const postVerifyPasswordRecovery = async (data) => {
  ////console.log(data);
  let token = await localStorage.getItem('registerToken')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/auth/signUp/otp/verify',
    headers: {
      flow: 'PASSWORD_RECOVERY',
      Authorization: 'Bearer ' + token,
    },
  });
};

export const getPasswordRecoveryToken = async (phoneNumber) => {
  return axiosFetch({
    headers: {
      flow: 'PASSWORD_RECOVERY',
    },
    method: "GET",
    url: `/auth/signIn/${phoneNumber}`
  })
}

export const PasswordRecoveryVerify = async (data) => {
  ////console.log(data);
  let token = await localStorage.getItem('recoveryPasswordToken')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/auth/signUp/otp/verify',
    headers: {
      flow: 'PASSWORD_RECOVERY',
      Authorization: 'Bearer ' + token,
    },
  });
};

export const putPreferredName = async (data) => {
  ////console.log(data);
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'PUT',
    data,
    url: '/auth/informations',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const getProfilePicture = async () => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'GET',
    url: '/auth/informations/upload',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
}

export const putProfilePicture = async (image) => {
  ////console.log(data);
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'PUT',
    data: {
      value: image
    },
    url: '/auth/informations/upload',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
}

export const updatePasswordWithToken = async (data) => {
  ////console.log(data);
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'PUT',
    data,
    url: '/auth/accounts/password',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
}

